import { chatFragment } from '../fragments';
import { makeRequest } from '../utils';

/**
 * @param {string} personId
 */
export const findPersonChat = personId =>
  makeRequest({
    operationName: 'PersonChat',
    query: `
      query PersonChat($personId: String!) {
        personChat(personId: $personId) {
          ...ChatFragment
        }
      }
      
      ${chatFragment}
    `,
    variables: { personId },
  });

/**
 * @param {number} take
 * @param {number} skip
 * @param {string?} search
 * @param {object?} searchFilter
 */
export const getChats = (take, skip, search, searchFilter) =>
  makeRequest({
    operationName: 'Chats',
    query: `
      query Chats($take: Int!, $skip: Int!, $search: String, $searchFilter: ChatSearchFilterInput) {
        chats(take: $take, skip: $skip, search: $search, searchFilter: $searchFilter) {
          ...ChatFragment
        }
      }
      
      ${chatFragment}
    `,
    variables: { take, skip, search, searchFilter },
  });

/**
 * @param {string} id
 */
export const getChat = id =>
  makeRequest({
    operationName: 'Chat',
    query: `
      query Chat($id: String!) {
        chat(id: $id) {
          ...ChatFragment
        }
      }
      
      ${chatFragment}
    `,
    variables: { id },
  });

export const getChatCount = () =>
  makeRequest({
    operationName: 'ChatCount',
    query: `
      query ChatCount {
        chatCount
      }
    `,
  });
